// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__Nqv9h","table":"List_table__1vwfu","sorted":"List_sorted__1DuEJ","increaseButton":"List_increaseButton__3iJqx","popUpAlign":"List_popUpAlign__3Vy4y"};